import { KPdfDialog } from "kinnect-general";
import {
	VDivider,
	VIcon,
	VList,
	VListGroup,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle,
	VSubheader
} from "vuetify/lib";

export default VList.extend( {
	name: "KNavList",

	props: {
		items: {
			required: true,
			type: Array
		}
	},

	computed: {
		propsToPass() {
			const {
				items,
				...propsToPass
			} = this.$props;

			return propsToPass;
		}
	},

	methods: {
		genItems( items, subGroup ) {
			if ( items && items.length ) {
				return items.map( ( item, i ) => this.genItem( item, i, subGroup ) );
			}
		},

		genItem( item, index, subGroup ) {
			if ( item.items ) {
				return <VListGroup
					key={`${item.title}-${index}-${subGroup}-group`}
					noAction
					prependIcon={item.icon}
					ripple
					subGroup={subGroup}
					vModel={item.isOpen}
				>
					<VListItemTitle slot="activator">{item.title}</VListItemTitle>

					{this.genItems( item.items, true )}
				</VListGroup>;
			} else if ( item.header ) {
				return <VSubheader
					key={`${item.header}-${index}-${subGroup}-header`}
					class="grey--text"
				>{item.header}</VSubheader>;
			} else if ( item.title ) {
				return this.genItemListTile( item, index, subGroup );
			} else if ( item.divider ) {
				return <VDivider key={`${index}-${subGroup}-divider`}></VDivider>;
			}
		},

		genItemListTile( item, index, subGroup ) {
			const baseAttrs = {
				exact: item.href.name === "front",
				href: item.target ? item.href : null,
				key: `${item.title}-${index}-${subGroup}-tile`,
				target: item.target ? item.target : null,
				to: item.target ? null : item.href
			};
			const listTileContent = [
				item.icon && <VListItemAction>
					<VIcon>{item.icon}</VIcon>
				</VListItemAction>,

				<VListItemContent>
					<VListItemTitle>{item.title}</VListItemTitle>
				</VListItemContent>
			];

			if ( item.dialog === "pdf" ) {
				return <KPdfDialog
					baseURL="/"
					scopedSlots={{
						activator: ( { on } ) =>
							<VListItem
								attrs={baseAttrs}
								on={on}
								onClick={e => e.preventDefault()}
							>{listTileContent}</VListItem>
					}}
					src={item.href}
					title={item.title}
				></KPdfDialog>;
			}

			return <VListItem attrs={baseAttrs}>{listTileContent}</VListItem>;
		}
	},

	render() {
		return <VList attrs={this.propsToPass} nav>
			{this.genItems( this.items, false )}
		</VList>;
	}
} );
